/* global _ moment */

/* @ngInject */
export default class {
  constructor($q, $log, ApiClass, ProfileClass) {
    this.$q = $q;
    this.$log = $log;
    this.ApiClass = ApiClass;
    this.ProfileClass = ProfileClass;
    this._request = false;
    this._request_error = false;
    this.all_regulators = [];
    this.regulator_dict = {};
    this.current_regulators = [];
    this.current_regulator_dict = {};
  }

  _clean() {
    this.all_regulators = [];
    this.regulator_dict = {};
    this.current_regulators = [];
    this.current_regulator_dict = {};
  }

  name(reg_id) {
    if (!this._request) this.loadRegulators();
    if (this._request.pending) return 'Loading...';
    return this.current_regulator_dict[reg_id].name;
  }

  basicName(reg_id) {
    if (!this._request) this.loadRegulators();
    if (this._request.pending) return 'Loading...';
    return this.current_regulator_dict[reg_id].basic_name;
  }

  /*
   * TODO this is just a patch. Remove after chore is completed.
   * #169028180 - Migrate regulator dates
   */
  momentDate(date) {
    let cleanedDate = date;
    if (cleanedDate.includes('T')) cleanedDate = date.split('T')[0];
    return moment(cleanedDate);
  }

  loadRegulators(update) {
    if (!update && (this._request && !this._request_error)) {
      return this._request;
    }

    const company_id = this.ProfileClass.company_id;

    this._clean();

    this._request = this.$q((resolve, reject) => {
      this.ApiClass.companiesIdTypeGet({
        id: company_id,
        type: 'regulators',
        manage: false
      })
        .then(({ data: { items: regulators } }) => {
          const { all, latest } = regulators.reduce(
            (obj, regulator) => {
              if (regulator.reg_id in obj.all === false) {
                obj.all[regulator.reg_id] = {};
                obj.all[regulator.reg_id].name = regulator.basic_name;
                obj.all[regulator.reg_id].basic_name = regulator.basic_name;
              }

              if (regulator.reg_id in obj.latest === false) {
                obj.latest[regulator.reg_id] = regulator;
                obj.latest[regulator.reg_id].name = regulator.name;
                obj.latest[regulator.reg_id].basic_name = regulator.basic_name;
              }

              if (regulator.date in obj.all[regulator.reg_id] === false) {
                obj.all[regulator.reg_id][regulator.date] = regulator;
              }

              if (
                this.momentDate(regulator.date).valueOf() > this.momentDate(obj.latest[regulator.reg_id].date).valueOf()
              ) {
                obj.all[regulator.reg_id].name = regulator.basic_name;
                obj.latest[regulator.reg_id] = regulator;
                obj.latest[regulator.reg_id].name = regulator.name;
                obj.latest[regulator.reg_id].basic_name = regulator.basic_name;
              }

              return obj;
            },
            { all: {}, latest: {} }
          );

          this.all_regulators.push(...regulators);
          this.regulator_dict = all;
          this.current_regulator_dict = latest;
          this.current_regulators = _.values(latest);

          this._request_error = false;

          resolve({
            obj: this.regulator_dict,
            arr: this.all_regulators,
            arrCurrent: this.current_regulators,
            objCurrent: this.current_regulator_dict
          });
        })
        .catch(error => {
          this._request_error = true;
          this.$log.error(error);
          reject(error);
          throw error;
        });
    });

    return this._request;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/RegulatorClass.js